import { AcknowledgementName } from "@wingspanhq/wingspan-api-sdk";
import { WS_LINKS } from "../../types/wsLinks";

export const bankingAcknowledgements: AcknowledgementName[] = [
  AcknowledgementName.DEPOSIT_ACCOUNT_HOLDER_AGREEMENT,
  AcknowledgementName.LEAD_BANK_TERMS,
  AcknowledgementName.ELECTRONIC_DISCLOSURE_AND_CONSENT
];

export const bankingAccountAcknowledgements: AcknowledgementName[] = [
  ...bankingAcknowledgements,
  AcknowledgementName.WINGSPAN_PRIVACY_POLICY_ACCEPTANCE,
  AcknowledgementName.WINGSPAN_TOS_ACCEPTANCE
];

export const taxWithholdingAccountAcknowledgements: AcknowledgementName[] = [
  ...bankingAcknowledgements,
  AcknowledgementName.WINGSPAN_PRIVACY_POLICY_ACCEPTANCE,
  AcknowledgementName.WINGSPAN_TOS_ACCEPTANCE
];

export const debitCardAcknowledgements: AcknowledgementName[] = [
  AcknowledgementName.DEBIT_CARD_HOLDER_AGREEMENT,
  AcknowledgementName.CASH_BACK_PROMOTION_AGREEMENT,
  ...bankingAccountAcknowledgements
];

// TODO: Add the rest of the acknowledgements
export const virtualCardAcknowledgements: AcknowledgementName[] = [
  AcknowledgementName.DEBIT_CARD_HOLDER_AGREEMENT,
  AcknowledgementName.CASH_BACK_PROMOTION_AGREEMENT,
  ...bankingAccountAcknowledgements
];

export const acknowledgementVersions: Record<AcknowledgementName, string> = {
  [AcknowledgementName.W9_CERTIFICATION]: "2024-03-01",
  [AcknowledgementName.W8_BEN_CERTIFICATION]: "2021-10-01",
  [AcknowledgementName.CANADIAN_TAX_PAYER_CERTIFICATION]: "2024-08-01",
  [AcknowledgementName.LOCAL_TAX_PAYER_CERTIFICATION]: "2024-08-01",
  [AcknowledgementName.WINGSPAN_TOS_ACCEPTANCE]: "2024-07-22",
  [AcknowledgementName.WINGSPAN_PRIVACY_POLICY_ACCEPTANCE]: "2024-07-22",
  [AcknowledgementName.DEPOSIT_ACCOUNT_HOLDER_AGREEMENT]: "2024-07-22",
  [AcknowledgementName.CASH_BACK_PROMOTION_AGREEMENT]: "2022-10-04",
  [AcknowledgementName.DEBIT_CARD_HOLDER_AGREEMENT]: "2022-07-22",
  [AcknowledgementName.MOOV_TERMS_OF_SERVICE]: "2024-02-05",
  [AcknowledgementName.LEAD_BANK_TERMS]: "2022-08-09",
  [AcknowledgementName.ELECTRONIC_TAX_FORM_CONSENT]: "2024-08-01",
  [AcknowledgementName.ELECTRONIC_DISCLOSURE_AND_CONSENT]: "2024-08-01",
  [AcknowledgementName.CURRENCY_CLOUD_TERMS]: "2024-08-01"
};

type AcknowledgementInfo = {
  link: string;
  title: string;
  description?: string;
};

export const acknowledgementInfo: Partial<
  Record<AcknowledgementName, AcknowledgementInfo>
> = {
  [AcknowledgementName.WINGSPAN_TOS_ACCEPTANCE]: {
    title: "Wingspan Terms of Service",
    link: WS_LINKS.wingspanTosAcceptance,
    description:
      "By using Wingspan's services, you agree to abide by our Terms of Service."
  },
  [AcknowledgementName.WINGSPAN_PRIVACY_POLICY_ACCEPTANCE]: {
    title: "Privacy Notice",
    description:
      "We value your privacy. Our Privacy Notice details how we collect, use, and protect your personal information.",
    link: WS_LINKS.wingspanPrivacyPolicyAcceptance
  },
  [AcknowledgementName.DEPOSIT_ACCOUNT_HOLDER_AGREEMENT]: {
    title: "Business Deposit Account Agreement",
    description:
      "By opening an account with us, you agree to the terms outlined in our Wingspan Business Deposit Account Agreement. Please review this document carefully.",
    link: WS_LINKS.depositAccountTermsConditions
  },
  [AcknowledgementName.CASH_BACK_PROMOTION_AGREEMENT]: {
    title: "Wingspan Cash Back Terms & Conditions",
    description:
      "Our cash back program is subject to specific terms and conditions.",
    link: WS_LINKS.cashBackTermsAndConditions
  },
  [AcknowledgementName.DEBIT_CARD_HOLDER_AGREEMENT]: {
    title: "Debit Card Holder Agreement",
    description:
      "Use of our debit card is governed by the Business VISA Debit Cardholder Agreement. This agreement outlines the terms and conditions for using your Wingspan debit card.",
    link: WS_LINKS.debitCardHolderAgreement
  },
  [AcknowledgementName.MOOV_TERMS_OF_SERVICE]: {
    title: "Moov Platform Agreement",
    description:
      "As part of our service infrastructure, we use Moov's platform. By using our services, you also agree to Moov's Platform Agreement, which governs certain aspects of payment processing.",
    link: WS_LINKS.moovTermsOfService
  },
  [AcknowledgementName.LEAD_BANK_TERMS]: {
    title: "Lead Bank Privacy Policy",
    description:
      "Banking services are provided by Lead Bank, member FDIC. By using our banking services, you also agree to Lead Bank's Terms of Use.",
    link: WS_LINKS.leadBankTerms
  },
  [AcknowledgementName.ELECTRONIC_DISCLOSURE_AND_CONSENT]: {
    title: "Electronic Disclosure and Consent",
    description:
      "By opening an account, you agree to receive all communications from us electronically. This includes important disclosures, notices, and other information related to your account.",
    link: WS_LINKS.electronicDisclosureAndConsent
  },

  // Tax certification acknowledgements are implemented separatelly
  [AcknowledgementName.W9_CERTIFICATION]: {
    title: "",
    description: "",
    link: ""
  },
  [AcknowledgementName.W8_BEN_CERTIFICATION]: {
    title: "",
    description: "",
    link: ""
  },
  [AcknowledgementName.CANADIAN_TAX_PAYER_CERTIFICATION]: {
    title: "",
    description: "",
    link: ""
  },
  [AcknowledgementName.LOCAL_TAX_PAYER_CERTIFICATION]: {
    title: "",
    description: "",
    link: ""
  },
  [AcknowledgementName.ELECTRONIC_TAX_FORM_CONSENT]: {
    title: "",
    description: "",
    link: ""
  }
};
